var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchoolIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "School"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6471 2.33824C11.8676 2.22059 12.1324 2.22059 12.3529 2.33824L23.6029 8.33824C23.8473 8.46858 24 8.72302 24 9C24 9.27698 23.8473 9.53142 23.6029 9.66176L12.3529 15.6618C12.1324 15.7794 11.8676 15.7794 11.6471 15.6618L0.397059 9.66176C0.152661 9.53142 0 9.27698 0 9C0 8.72302 0.152661 8.46858 0.397059 8.33824L11.6471 2.33824ZM2.34375 9L12 14.15L21.6562 9L12 3.85L2.34375 9Z",
    fill: "#4A4C4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.3382 8.64706C11.5332 8.28158 11.9875 8.14331 12.3529 8.33824L17.9779 11.3382C18.2223 11.4686 18.375 11.723 18.375 12V22.5C18.375 22.9142 18.0392 23.25 17.625 23.25C17.2108 23.25 16.875 22.9142 16.875 22.5V12.45L11.6471 9.66176C11.2816 9.46684 11.1433 9.01254 11.3382 8.64706Z",
    fill: "#4A4C4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.375 9.64687C3.78921 9.64687 4.125 9.98265 4.125 10.3969V15.5062L4.12664 15.5083C4.68285 16.2555 7.14899 19.125 12 19.125C16.851 19.125 19.3172 16.2555 19.8734 15.5084L19.875 15.5062V10.3969C19.875 9.98265 20.2108 9.64687 20.625 9.64687C21.0392 9.64687 21.375 9.98265 21.375 10.3969V15.5156L21.375 15.5188C21.3736 15.8397 21.2681 16.1515 21.0743 16.4072C20.3702 17.3518 17.5116 20.625 12 20.625C6.48837 20.625 3.62978 17.3517 2.92573 16.4072C2.73193 16.1515 2.62636 15.8397 2.62501 15.5188L2.62499 15.5156L2.625 10.3969C2.625 9.98265 2.96079 9.64687 3.375 9.64687Z",
    fill: "#4A4C4F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolIcn);
export default __webpack_public_path__ + "static/media/schoolIcn.8cc061da59bd6f45e1f01e74e7ecb64d.svg";
export { ForwardRef as ReactComponent };